import { EOrdering } from '../../repositories/journal/v1/get-comments';

/**
 * Проверяет и корректирует значение сортировки для комментов
 * Значение должно входить в EOrdering
 */
export const prepareCommentsOrdering = (ordering: string | string[]) => {
  if (!ordering || !ordering.length) {
    return;
  }

  const orderingPrepared = (typeof ordering === 'string' ? ordering : ordering[0]).toLowerCase();

  if (!(Object.values(EOrdering) as string[]).includes(orderingPrepared)) {
    return;
  }

  return orderingPrepared as EOrdering;
};
